import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function PaymentRemoveIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        d="M15 23.75C13.3344 24.528 11.1463 25 8.75 25C7.4176 25 6.14961 24.8541 5 24.5907C4.261 24.4215 3.89149 24.3369 3.44873 23.9865C3.1962 23.7867 2.88104 23.3911 2.74265 23.1004C2.5 22.5906 2.5 22.0962 2.5 21.1075V7.64246C2.5 6.41142 3.80004 5.56591 5 5.84075C6.14961 6.10406 7.4176 6.25 8.75 6.25C11.1463 6.25 13.3344 5.77795 15 5C16.6656 4.22205 18.8536 3.75 21.25 3.75C22.5824 3.75 23.8504 3.89594 25 4.15925C25.739 4.32851 26.1085 4.41314 26.5512 4.76349C26.8037 4.9633 27.119 5.35881 27.2574 5.64957C27.5 6.15939 27.5 6.65374 27.5 7.64246V15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        fill="none"
        d="M18.75 22.5H27.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        fill="none"
        d="M18.125 15C18.125 16.7259 16.7259 18.125 15 18.125C13.2741 18.125 11.875 16.7259 11.875 15C11.875 13.2741 13.2741 11.875 15 11.875C16.7259 11.875 18.125 13.2741 18.125 15Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        fill="none"
        d="M6.875 16.25V16.2612"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="none"
        d="M23.125 13.7422V13.7534"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
